var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const EditorHostPlugin = {
  injectApi(bridge) {
    return {
      Ku: {
        editor: {
          transform: {
            async insertNodes(nodes, options) {
              return bridge.callApi("editor-op", {
                type: "insertNodes",
                nodes,
                options
              });
            },
            async setNodes(nodes, options) {
              return bridge.callApi("editor-op", {
                type: "setNodes",
                nodes,
                options
              });
            },
            async removeNodes(options) {
              return bridge.callApi("editor-op", {
                type: "removeNodes",
                options
              });
            },
            async setSelection(options) {
              return bridge.callApi("editor-op", {
                type: "setSelection",
                options
              });
            },
            // 根据path获取节点信息
            async get(path) {
              return bridge.callApi("editor-get", {
                path
              });
            }
          }
        }
      }
    };
  }
};
const EditorClientPlugin = {
  setupBridge(bridge) {
    bridge.registerApi("editor-op", (data) => {
      const editor = window.morphoEditor || window.baiduRteStore.STORE_EDITOR;
      const { type, nodes, options } = data || {};
      if (!editor || !type || !options) {
        return;
      }
      if (nodes) {
        editor.getTransformService()[type](nodes, options);
      } else {
        editor.getTransformService()[type](options);
      }
    });
    bridge.registerApi("editor-get", (data) => {
      const editor = window.morphoEditor || window.baiduRteStore.STORE_EDITOR;
      const { path } = data || {};
      if (!editor || !Array.isArray(path)) {
        return;
      }
      if (path.length === 0) {
        return editor.children;
      }
      let node = editor;
      while (path.length > 0) {
        node = node.children[path.shift()];
      }
      return node;
    });
  }
};
function createDeepProxy(callback, path = "") {
  const handler = {
    get(obj, prop) {
      const currentPath = path ? `${path}.${prop}` : prop;
      return createDeepProxy(callback, currentPath);
    },
    apply(target, thisArg, args) {
      let result;
      if (callback) {
        result = callback(path, args);
      } else {
        console.log(`${path}()`);
      }
      return result !== void 0 ? result : createDeepProxy(callback, path);
    }
  };
  return new Proxy(function() {
  }, handler);
}
__name(createDeepProxy, "createDeepProxy");
function callFromWindow(path, args = []) {
  const pathParts = path.split(".");
  let current = window.BdHiJs;
  if (!current) {
    console.warn("window.BdHiJs 不存在");
    return;
  }
  for (let i = 0; i < pathParts.length - 1; i++) {
    const part = pathParts[i];
    if (!(part in current)) {
      console.warn(`${pathParts.slice(0, i + 1).join(".")} 不存在`);
      return;
    }
    current = current[part];
    if (current === null || typeof current !== "object" && typeof current !== "function") {
      console.warn(`${pathParts.slice(0, i + 1).join(".")} not a object`);
      return;
    }
  }
  const lastPart = pathParts[pathParts.length - 1];
  if (!(lastPart in current)) {
    console.warn(`${path} 不存在`);
    return;
  }
  const target = current[lastPart];
  if (target === void 0) {
    console.warn(`${path} is undefined`);
    return;
  }
  if (typeof target === "function") {
    return target(...args);
  }
  return target;
}
__name(callFromWindow, "callFromWindow");
const BdHiJsHostPlugin = {
  injectApi(bridge) {
    const cb = /* @__PURE__ */ __name((path, args) => {
      return bridge.callApi("BdHiJs", {
        path,
        args
      });
    }, "cb");
    return {
      BdHiJs: createDeepProxy(cb)
    };
  }
};
const BdHiJsClientPlugin = {
  setupBridge(bridge) {
    bridge.registerApi("BdHiJs", (data) => {
      if (typeof window.BdHiJs !== "undefined") {
        const { path, args } = data || {};
        return callFromWindow(path, args);
      }
    });
  }
};
export {
  BdHiJsHostPlugin as B,
  EditorHostPlugin as E,
  EditorClientPlugin as a,
  BdHiJsClientPlugin as b
};
//# sourceMappingURL=BdHiJs-BoUJUuIZ.js.map
